<template>
  <div class="afdc-list-results afdc-corridor-list afdc-d-flex afdc-flex-column afdc-justify-content-between">
    <div class="afdc-corridor-station-container">
      <h5>{{ $t('Starting Station') }} </h5>
      <div class="afdc-station afdc-row afdc-no-gutters afdc-corridor-station">
        <div id="afdc-clear-corridor-station" v-if="startStation.station_name">
          <button @click="clearInput('start')"><span class="afdc-sr-only">{{ $t('Clear') }}</span><font-awesome-icon icon="times-circle" class="afdc-fa-icon afdc-corridor-clear"/> </button>
        </div>
        <div class="afdc-col-auto afdc-corridor-pin-column" v-if="startStation.station_name">
          <img class="afdc-corridor-route-pin" src="@/assets/images/pins/start.png" alt="route start pin" />
        </div>
        <div class="afdc-col-10 afdc-corridor-station-name" v-if="startStation.station_name">
          <strong>{{ startStation.station_name }} </strong><br/>
          {{ startStation.street_address }}
          <br />
          {{ stationCityStateZip(startStation.city, startStation.state, startStation.zip) }}
          <br />
          <p class ="afdc-highway-miles" :class="checkHighwayDistance('start')" v-if="startDistanceToHighway">{{startDistanceToHighway}} {{$t('miles to Interstate Highway')}}</p>
        </div>
        <div class="afdc-col-md-12" v-else>
          <em>{{ $t('Select a station on the map to choose your starting point.') }} </em>
        </div>
      </div>
      <h5>{{ $t('Ending Station') }} </h5>
      <div class="afdc-station afdc-row afdc-no-gutters afdc-corridor-station">
        <div id="afdc-clear-corridor-station"  v-if="endStation.station_name">
          <button @click="clearInput('end')"><span class="afdc-sr-only">{{ $t('Clear') }}</span><font-awesome-icon icon="times-circle" class="afdc-fa-icon afdc-corridor-clear"/></button>
        </div>
        <div class="afdc-col-auto afdc-corridor-pin-column" v-if="endStation.station_name">
          <img class ="afdc-corridor-route-pin" src="@/assets/images/pins/end.png" alt="route start pin" />
        </div>
        <div class="afdc-col-10 afdc-corridor-station-name" v-if="endStation.station_name">
          <strong>{{ endStation.station_name }} </strong><br />
          {{ endStation.street_address }}
          <br />
          {{ stationCityStateZip(endStation.city, endStation.state, endStation.zip) }}
          <br />
          <p class ="afdc-highway-miles" :class="checkHighwayDistance('end')" v-if="endDistanceToHighway">{{endDistanceToHighway}} {{$t('miles from Interstate Highway')}}</p>
        </div>
        <div class="afdc-col-md-12" v-else>
          <em>{{ $t('Select a station on the map to choose your ending point.') }} </em>
        </div>
      </div>
      <div class="afdc-form-group afdc-route-options">
        <div class="afdc-custom-control afdc-custom-checkbox">
          <input type="checkbox" class="afdc-custom-control-input" v-model="advancedRoute" :id="'showRoute'" >
          <label class="afdc-custom-control-label" :for="'showRoute'">{{ $t('Advanced Route Preferences') }}</label>
        </div>
        <div class="afdc-radio-route-select" v-if="advancedRoute">
          <div class="afdc-custom-control afdc-custom-radio afdc-custom-control-inline">
            <input type="radio" v-model="routeType" value="highway" id="afdc-corridor-highway-route" class="afdc-custom-control-input">
            <label class="afdc-custom-control-label" for="afdc-corridor-highway-route">{{ $t('Highways') }}</label>
          </div>
          <div class="afdc-custom-control afdc-custom-radio afdc-custom-control-inline">
            <input type="radio" v-model="routeType" value="fastest" id="afdc-corridor-fastest-route" class="afdc-custom-control-input">
            <label class="afdc-custom-control-label" for="afdc-corridor-fastest-route">{{ $t('Fastest') }}</label>
          </div>
        </div>
      </div>
      <div class = "afdc-corridor-info-container afdc-d-flex afdc-flex-column">
        <div class="afdc-row" v-if="highwayDistanceOver">
          <div class = "afdc-col-lg afdc-directions-description afdc-corridor-over">
            <em>{{ $t('Stations must be within 5 miles from the Interstate Highway.')}}</em>
          </div>
        </div>
      </div>
      <div class = "afdc-corridor-info-container afdc-d-flex afdc-flex-column">
        <div class="afdc-row" v-if="corridorErrorMessage">
          <div class = "afdc-col-lg afdc-directions-description afdc-corridor-over">
            <em>{{ corridorErrorMessage }}</em>
          </div>
        </div>
      </div>
    </div>

    <div class = "afdc-corridor-info-container afdc-d-flex afdc-flex-column">
      <div class="afdc-row afdc-justify-content-center afdc-distance-row">
        <div v-if ="corridorDistance" class = "afdc-d-flex afdc-align-items-center afdc-flex-column">
          <div class="afdc-d-flex afdc-align-items-center afdc-distance-container " :class='checkCorridorDistance'>
            <h5 class ="afdc-distance-heading">{{corridorDistance}}</h5>
            <h5>{{ $t('miles') }}</h5>
          </div>
          <span class = "afdc-distance-description">{{ $t('driving distance between the stations') }} </span>
        </div>
      </div>
      <div class="afdc-row afdc-d-flex afdc-justify-content-center">
        <button v-if="displayDirectionsButton" class="afdc-btn afdc-btn-secondary" @click="toggleCorridorDirections">
          <font-awesome-icon icon="car" class="afdc-fa-icon"/>&nbsp;
          {{ $t('See Route Directions') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CorridorResults',

  data() {
    return {
      startStation: {},
      endStation: {},
      previousCorridorDistance: null,
      isCorridorReady: false,
      startDistanceToHighway: null,
      endDistanceToHighway: null,
      highwayDistanceOver: false,
      noHighwayDistance: false,
      advancedRoute: false,
    };
  },

  watch: {
    '$store.getters.getCorridorRouteStart': {
      immediate: true,
      handler: 'setCorridorStart',
    },
    '$store.getters.getCorridorRouteEnd': {
      immediate: true,
      handler: 'setCorridorEnd',
    },
    '$store.getters.isNavActiveTabCorridorsSearchPresent': {
      immediate: true,
      handler: 'setCorridorReady',
    },
    '$store.getters.getCorridorDistanceToHighway': {
      immediate: true,
      handler: 'setDistanceToHighway',
    },
    '$store.getters.getLoadingCorridorStations': {
      immediate: true,
      handler: 'checkLoading',
    },
    '$store.getters.getRouteType': {
      immediate: true,
      handler: 'fetchData',
    },
  },
  computed: {
    corridorDistance: {
      get() {
        const newDistance = this.$store.getters.getCorridorDistance || null;
        const distanceFormat = { minimumFractionDigits: 0, maximumFractionDigits: 0 };

        if (this.isCorridorReady && this.previousCorridorDistance !== newDistance && !this.$store.getters.getLoadingCorridorStations) {
          return this.$formatNumber(newDistance, distanceFormat);
        } return null;
      },
      set(newValue) {
        this.previousCorridorDistance = newValue;
      },
    },
    routeType: {
      get() {
        return this.$store.getters.getRouteType;
      },
      set(newValue) {
        this.$store.commit('setRouteType', newValue);
      },
    },
    checkCorridorDistance() {
      const overDistance = this.$store.getters.isCorridorDistanceOverAllowed;
      if (overDistance) {
        return 'afdc-corridor-over';
      } return '';
    },

    displayDirectionsButton() {
      if (this.isCorridorReady && !this.$store.getters.getLoadingCorridorStations && this.displayDirections) {
        return true;
      } return false;
    },

    displayDirections() {
      return this.$store.getters.isDisplayDirections;
    },

    corridorErrorMessage() {
      const stationsLoading = this.$store.getters.getLoadingCorridorStations;
      const corridorApiError = this.$store.getters.getCorridorError || null;
      if (corridorApiError !== null) {
        return corridorApiError;
        /* eslint-disable no-else-return */
      } else if (this.noHighwayDistance && !stationsLoading) {
        return this.$t('This route does not include an Interstate Highway.');
      } return '';
    },
  },
  methods: {
    checkHighwayDistance(point) {
      let distanceClass = '';
      const pointDistance = point === 'end' ? this.endDistanceToHighway : this.startDistanceToHighway;
      if (pointDistance > 5) {
        distanceClass = 'afdc-corridor-over';
      }
      return distanceClass;
    },
    checkLoading() {
      const loading = this.$store.getters.getLoadingCorridorStations;
      if (loading) {
        this.startDistanceToHighway = null;
        this.endDistanceToHighway = null;
        this.highwayDistanceOver = false;
      }
    },
    /* eslint-disable consistent-return */
    setDistanceToHighway() {
      const distanceObject = this.$store.getters.getCorridorDistanceToHighway;
      this.highwayDistanceOver = false;
      this.noHighwayDistance = false;
      this.startDistanceToHighway = null;
      this.endDistanceToHighway = null;
      if (this.isCorridorReady) {
        if (distanceObject.start_to_highway || distanceObject.start_to_highway === 0) {
          this.startDistanceToHighway = (distanceObject.start_to_highway).toFixed(1);
        }
        if (distanceObject.highway_to_end || distanceObject.highway_to_end === 0) {
          this.endDistanceToHighway = (distanceObject.highway_to_end).toFixed(1);
        }
        if (this.startDistanceToHighway > 5 || this.endDistanceToHighway > 5) {
          this.highwayDistanceOver = true;
        }
        if (!distanceObject.start_to_highway && !distanceObject.highway_to_end) {
          this.noHighwayDistance = true;
        }
      } else {
        return null;
      }
    },
    /* eslint-enable consistent-return */
    setCorridorStart() {
      if (this.$store.getters.isNavActiveTabCorridors) {
        this.startStation = this.$store.getters.getCorridorRouteStart;
        if (this.startStation.station_name) {
          const coordinates = `${this.startStation.latitude},${this.startStation.longitude}`;
          this.$router.push({ query: { ...this.$route.query, start: coordinates } });
        } else {
          this.$router.push({ query: { ...this.$route.query, start: undefined } });
        }
        this.fetchData();
      }
    },
    setCorridorEnd() {
      if (this.$store.getters.isNavActiveTabCorridors) {
        this.endStation = this.$store.getters.getCorridorRouteEnd;
        if (this.endStation.station_name) {
          const coordinates = `${this.endStation.latitude},${this.endStation.longitude}`;
          this.$router.push({ query: { ...this.$route.query, end: coordinates } });
        } else {
          this.$router.push({ query: { ...this.$route.query, end: undefined } });
        }
        this.fetchData();
      }
    },

    setCorridorReady() {
      this.isCorridorReady = this.$store.getters.isNavActiveTabCorridorsSearchPresent;
      this.setDistanceToHighway();
      if (!this.isCorridorReady) {
        this.startDistanceToHighway = null;
        this.endDistanceToHighway = null;
        this.highwayDistanceOver = false;
      }
    },

    clearInput(param) {
      if (param === 'start') {
        this.startStation = {};
        this.$store.commit('setCorridorRouteStart', {});
        this.$router.push({ query: { ...this.$route.query, start: undefined } });
      } else {
        this.endStation = {};
        this.$store.commit('setCorridorRouteEnd', {});
        this.$router.push({ query: { ...this.$route.query, end: undefined } });
      }
    },
    fetchData() {
      const filterResults = this.$store.getters.getFiltersWithDefaults;
      if (filterResults.end && filterResults.start) {
        this.$store.dispatch('fetchCorridorStations', this.$store.getters.getFiltersWithDefaults);
      }
    },
    toggleCorridorDirections() {
      this.$store.commit('setDirectionPopup', true);
    },
  },
};
</script>

<style lang="scss">
  .corridor-list {
    padding: 0px 20px 10px 20px !important;
    .station {
      &:hover {
        background: #fff;
        border: 1px solid #fff;
        cursor: auto;
      }
    }

  .corridor-station {
    position: relative;
  }

  .corridor-station-name {
    margin-left: 10px;
  }

  #clear-corridor-station {
    position: absolute;
    color:#999;
    font-size: 25px;
    top: 0;
    right: 5px;
  }

  .corridor-clear {
    cursor: pointer;
  }

  .distance-description {
    text-align: center;
    line-height: 17px;
  }

  .directions-description {
    line-height: 17px;
    margin-bottom: 25px;
    text-align: center;
  }

  .distance-heading {
    font-size: 50px;
    margin-right: 7px;
  }

  .corridor-link-icon {
    font-size: 45px;
  }

  .corridor-route-pin {
    height: 45px;
  }
  .corridor-pin-icon {
    margin-right: 5px;
  }
  .corridor-download-link {
    color: black;
    &:hover {
      color: #3c3c3c;
    }
  }

  .highway-miles {
    margin-top: 10px;
    margin-bottom: 0;
  }

  .link-paragraph {
    line-height: 17px;
    margin-left: 10px;
  }
  .distance-container {
    h5 {
      margin: 0 0 0 5px;
      padding: 0;
    }
  }
  .corridor-over {
    color: #dd4733;
  }

  .btn-secondary {
    background-color: #555;
    border-color: #555;
    margin-top: 20px;
      &:hover {
      background-color: #3c3c3c;
    }
  }

    @media(max-width: 950px) {
      .list-results {
        padding: 0 20px 5px 20px;
      }

      .directions-description {
        margin-bottom: 5px;
      }
      .distance-heading {
        font-size: 35px;
      }

      .route-options {
        margin-bottom: 5px;
      }
      .highway-miles {
        margin-top: 5px;
      }
      .distance-description {
        line-height: 5px;
      }
    }

    @media(max-width: 767px) {
       .corridor-download-column {
          display: flex;
          justify-content: center;
        }

        .link-paragraph {
          text-align: center;
        }
    }

    @media(max-width: 1200px) and (min-width:768px) {
      .corridor-download-column {
        display: none;
      }

      .link-paragraph {
        margin-left: 0;
      }
    }
  }

</style>
